import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppService} from "./store/app/app.service";
import {environment} from "../environments/environment";
import {enableAkitaProdMode} from "@datorama/akita";
import {EdgeAuthService} from "./store/auth/edge-auth.service";
import {RouterOutlet} from "@angular/router";

@Component({
  selector: 'as-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  constructor(
    private appService: AppService,
    private edgeAuthService: EdgeAuthService,
  ) {
    this.edgeAuthService.refresh();
    if (environment.production) {
      enableAkitaProdMode();
    }
  }

  ngOnInit(): void {
    this.appService.init();
  }

}
